/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesUserSchema } from "./userSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesUserStatsSchema = z.object({
  userId: z.string().nullish(),
  get user() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
  totalTournaments: z.optional(z.int()),
  wins: z.optional(z.int()),
  winrate: z.optional(z.number()),
  matchWins: z.optional(z.int()),
  matchLosses: z.optional(z.int()),
  matchWinrate: z.optional(z.number()),
  rank: z.optional(z.int()),
  kda: z.string().nullish(),
});
